package fr.manyverse.app.presentation.components.common_tabs

import androidx.compose.animation.animateColorAsState
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.ContentCopy
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import fr.manyverse.app.infrastructure.clipboard.ClipboardManager
import kotlinx.coroutines.delay
import manyverse.shared.generated.resources.Res
import manyverse.shared.generated.resources.copy_table_code
import org.jetbrains.compose.resources.stringResource
import org.koin.compose.koinInject

@Composable
fun GameCodeCard(
    code: String,
    modifier: Modifier = Modifier,
    clipboardManager: ClipboardManager = koinInject()
) {
    var isCopied by remember { mutableStateOf(false) }

    // Reset the copied state after 1.5 seconds
    LaunchedEffect(isCopied) {
        if (isCopied) {
            delay(1500)
            isCopied = false
        }
    }

    val containerColor by animateColorAsState(
        targetValue = if (isCopied) {
            MaterialTheme.colorScheme.primaryContainer
        } else {
            MaterialTheme.colorScheme.secondaryContainer
        },
        label = "containerColor"
    )

    val contentColor by animateColorAsState(
        targetValue = if (isCopied) {
            MaterialTheme.colorScheme.onPrimaryContainer
        } else {
            MaterialTheme.colorScheme.onSecondaryContainer
        },
        label = "contentColor"
    )

    Card(
        colors = CardDefaults.cardColors(
            containerColor = containerColor
        ),
        modifier = modifier
            .clickable {
                clipboardManager.copyToClipboard(code)
                isCopied = true
            }
    ) {
        Row(
            modifier = Modifier.padding(horizontal = 12.dp, vertical = 6.dp),
            horizontalArrangement = Arrangement.spacedBy(8.dp),
            verticalAlignment = Alignment.CenterVertically
        ) {
            Text(
                text = code,
                style = MaterialTheme.typography.titleLarge,
                fontWeight = FontWeight.Bold,
                color = contentColor
            )
            Icon(
                imageVector = Icons.Default.ContentCopy,
                contentDescription = stringResource(Res.string.copy_table_code),
                tint = contentColor,
                modifier = Modifier.size(18.dp)
            )
        }
    }
}